// TODO: import from @report/graphql

import { ExamCourseType, type MonthAbbreviation } from './types';

export const THAI_MONTH_NAMES: Record<MonthAbbreviation, string> = {
  JAN: 'มกราคม',
  FEB: 'กุมภาพันธ์',
  MAR: 'มีนาคม',
  APR: 'เมษายน',
  MAY: 'พฤษภาคม',
  JUN: 'มิถุนายน',
  JUL: 'กรกฎาคม',
  AUG: 'สิงหาคม',
  SEP: 'กันยายน',
  OCT: 'ตุลาคม',
  NOV: 'พฤศจิกายน',
  DEC: 'ธันวาคม',
};

export const MONTH_ORDER = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
] as const;

export const MONTH_OPTIONS = MONTH_ORDER.map((monthAbbr) => ({
  label: THAI_MONTH_NAMES[monthAbbr],
  value: monthAbbr,
}));

export const EXAM_COURSE_TYPE_TEXT: Record<ExamCourseType, string> = {
  [ExamCourseType.Main]: 'Main',
  [ExamCourseType.Mock]: 'Mock',
};

export const EXAM_COURSE_TYPE_OPTIONS = [
  {
    label: EXAM_COURSE_TYPE_TEXT[ExamCourseType.Main],
    value: ExamCourseType.Main,
  },
  {
    label: EXAM_COURSE_TYPE_TEXT[ExamCourseType.Mock],
    value: ExamCourseType.Mock,
  },
] as const;
